import React from 'react';
import { Input, InputNumber, Space } from 'antd';
import styles from '../../../event-timeline.module.css';

interface PlayAudioParamsProps {
  params: any;
  setParams: (params: any) => void;
}

const PlayAudioParams: React.FC<PlayAudioParamsProps> = ({
  params,
  setParams,
}) => {
  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <span className={styles.label}>Audio URL:</span>
        <Input
          value={params.audioURL || ''}
          onChange={(e) => setParams({ ...params, audioURL: e.target.value })}
          placeholder='Enter audio URL'
        />
        <span className={styles.label}>Volume:</span>
        <InputNumber
          value={params.volume || 1.0}
          onChange={(value) => setParams({ ...params, volume: value })}
          min={0}
          max={1}
          step={0.1}
          style={{ width: '100%' }}
        />
      </Space>
    </div>
  );
};

export default PlayAudioParams;
